import React from "react";
import { useTranslation } from "react-i18next";

function AccountInfo({ accountNumber, bankLogo }) {
  const { t } = useTranslation();

  return (
    <div className="flex gap-10 justify-between items-center mt-2.5 w-full">
      <div className="self-stretch my-auto text-xs text-black">
        {t("profile.accountInfo.fromAccount")}
      </div>
      <div className="flex flex-col items-end self-stretch my-auto">
        <div className="text-xs text-black">{accountNumber}</div>
        <div className="flex overflow-hidden gap-2.5 justify-center items-center py-1 pr-1 pl-1 bg-white rounded border border-solid border-stone-200 min-h-[16px] ">
          <img
            loading="lazy"
            src={bankLogo}
            className="object-contain self-stretch my-auto aspect-[3.91] w-[46px]"
            alt="Bank logo"
          />
        </div>
      </div>
    </div>
  );
}

export default AccountInfo;
